export const ROUTES = {
  ROOT: '/',
  NEWS: '/aktualnosci',
  TEAM: '/team',
  REHABILITACJA: '/rehabilitacja',
  CENNIK: '/cennik',
  KONTAKT: '/kontakt',
};
